"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlockScroll = exports.lockScroll = void 0;
var getScrollbarWidth_1 = __importDefault(require("./getScrollbarWidth"));
var lockedIds = {};
var originalStyles = {
    body: {
        overflow: "",
        paddingRight: "",
    },
    documentElement: {
        overflow: "",
    },
};
var lockScroll = function (id, cb) {
    if (!Object.keys(lockedIds).length) {
        var body = document.body, documentElement = document.documentElement;
        var rect = body.getBoundingClientRect();
        var isOverflowing = rect.left + rect.right < window.innerWidth;
        originalStyles.body.overflow = body.style.overflow;
        originalStyles.documentElement.overflow = documentElement.style.overflow;
        documentElement.style.overflow = "hidden";
        if (isOverflowing) {
            var scrollBarWidth = (0, getScrollbarWidth_1.default)();
            originalStyles.body.paddingRight = body.style.paddingRight;
            body.style.paddingRight = "".concat(scrollBarWidth, "px");
        }
        cb === null || cb === void 0 ? void 0 : cb();
    }
    lockedIds[id] = true;
};
exports.lockScroll = lockScroll;
var unlockScroll = function (id, cb) {
    delete lockedIds[id];
    if (Object.keys(lockedIds).length)
        return;
    var body = document.body, documentElement = document.documentElement;
    if (originalStyles.documentElement.overflow &&
        /**
         * We don't restore the overflow to hidden in case it was controlled by a component outside of BUI React
         * In case it should be hidden – 3rd party component should lock the scroll again after it was unlocked
         * That's the best trade-off we've found for the following use case:
         * - 3rd party modal opens (scroll gets locked)
         *    -> BUI React modal opens (saves overflow hidden in lock)
         *    -> 3rd party modal closes
         *    -> BUI React modal closes (restores hidden overflow)
         *
         * It doesn't handle the use case when 3rd party modal is still opened,
         * but they have control over updating the overflow themselves and it's better than locking the page scroll completely
         */
        originalStyles.documentElement.overflow !== "hidden") {
        documentElement.style.overflow = originalStyles.documentElement.overflow;
    }
    else {
        document.documentElement.style.removeProperty("overflow");
    }
    if (originalStyles.body.overflow &&
        originalStyles.body.overflow !== "hidden") {
        body.style.overflow = originalStyles.body.overflow;
    }
    else {
        body.style.removeProperty("overflow");
    }
    if (originalStyles.body.paddingRight) {
        body.style.paddingRight = originalStyles.body.paddingRight;
    }
    else {
        body.style.removeProperty("padding-right");
    }
    originalStyles.documentElement.overflow = "";
    originalStyles.body.overflow = "";
    originalStyles.body.paddingRight = "";
    cb === null || cb === void 0 ? void 0 : cb();
};
exports.unlockScroll = unlockScroll;
